// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2w189","approved":"Status_approved__3uGLX","rejected":"Status_rejected__2MBKM","expired":"Status_expired__33YVz","label":"Status_label__Is91D"};